import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const sessionActivityItem = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    textValue: z.string().nullable().optional().describe('Text Value'),

    numberValue: z.number().nullable().optional().describe('Number Value'),

    sessionId: z.number().hidden().describe('Foreign key to Session'),

    activityItemId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ActivityItem'),

    resourceId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Resource'),

    session: belongsTo('Session'),

    activityItem: references('ActivityItem'),

    resource: references('Resource'),
  })
  .describe(
    'One activity item worked through during a session, with the recorded value.',
  )
  .as('SessionActivityItem');

export { sessionActivityItem as sessionActivityItemSchema };
